import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { POINT_PAGE_NAME } from '../../constants/service/app/pointConstants';
import PointRankingListContainer from '../../containers/point/PointRankingListContainer';

const PointRankingList = () => {
  return (
    <PageTemplate pageName={POINT_PAGE_NAME.POINT_RANKING}>
      <PointRankingListContainer />
    </PageTemplate>
  );
};

export default PointRankingList;
